import styled, { css } from 'styled-components'

import { CustomTextAreaInputProps } from '@/@types/global'
import {
  withColor,
  withFontSize,
  withMargin,
  withMinHeight,
  withPadding,
} from '@/utils/styled-decorators'

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  text-align: left;
  font-size: ${({ theme }) => theme.fontSizes['text-sm']};
  margin: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors['neutral-color-60']};
  vertical-align: middle;

  .message-icon {
    ${({ theme }) => css`
      min-width: ${theme.fontSizes.medium};
      width: ${theme.fontSizes.medium};
      min-height: ${theme.fontSizes.medium};
      height: ${theme.fontSizes.medium};
    `}
    margin-right: 8px;
  }
`

export const StyledTextAreaInput = styled.textarea<CustomTextAreaInputProps>`
  ${withMargin('8px 0px')}
  ${withColor('neutral-color-60')}
  ${withFontSize('medium')}
  ${withPadding('8px 16px')}
  ${withMinHeight('130px')}
  resize:none;
  width: 100%;
  min-height: ${({ theme, minHeight }) => theme.spacing[minHeight || 44]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  border-radius: ${({ theme }) => theme.borderRadius.input};
  font-family: 'Roboto';
  outline: none;
  box-sizing: border-box;
  border: 2px solid ${({ theme }) => theme.colors.lightGray};
  transition: border 0.2s linear;
  ${({ success, theme }) =>
    success &&
    css`
      border: 2px solid ${theme.colors.success};
    `}
  ${({ warning, theme }) =>
    warning &&
    css`
      border: 2px solid ${theme.colors.warning};
    `}
  ${({ error, theme }) =>
    error &&
    css`
      border: 2px solid ${theme.colors.error};
    `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.lightGray};
  }
`

export const Label = styled.label`
  white-space: nowrap;
  margin-right: 8px;
`
